import {ReactElement} from "react";
import {styled} from "styled-components";

import {quicksandMedium, quicksandSemiBold} from "@/GlobalStyle";
import {KpiAvancement} from "@/ts/kpi";

const TableauContent = styled.div`
  border: 3px solid ${({theme}) => theme.colors.lightPrimary};
  width: auto;
  min-width: min-content;
  height: fit-content;
  margin: auto 0;
`;

const TableauRow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  & > div:first-child {
    border-right: 3px solid ${({theme}) => theme.colors.lightPrimary};
  }
`;

const TableauElement = styled.div`
  flex: 1;
  min-width: 90px;
  display: flex;
  flex-direction: column;
  & h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 2rem;
    height: max-content;
    width: auto;
    margin: 0;
    font-size: 1rem;
    background-color: ${({theme}) => theme.colors.lightPrimary};
    color: white;
    text-align: center;
    padding: 5px 10px;
    ${quicksandMedium}
    flex:1;
  }
  & p {
    min-height: 2.75rem;
    text-align: center;
    line-height: 2.75rem;
    color: ${({theme}) => theme.colors.lightPrimary};
    ${quicksandSemiBold}
    width: auto;
  }
`;

export function TableauAvancement({
  avancement,
}: {
  avancement?: KpiAvancement;
}): ReactElement | null {
  if (avancement) {
    return (
      <TableauContent data-testid="TableauContent">
        <TableauRow data-testid="TableauRow-1">
          <TableauElement data-testid="TableauElement-atteint">
            <h4>Objectif atteint</h4>
            <p>
              {avancement?.nb_objectif_valide !== undefined
                ? avancement?.nb_objectif_valide
                : ""}
            </p>
          </TableauElement>
          <TableauElement data-testid="TableauElement-currentBonus">
            <h4>Bonus actuel </h4>
            <p>
              {avancement?.current_bonus !== undefined
                ? `${avancement?.current_bonus} ${avancement?.current_bonus_unit}`
                : ""}
            </p>
          </TableauElement>
        </TableauRow>
        <TableauRow data-testid="TableauRow-2">
          <TableauElement data-testid="TableauElement-inProgress">
            <h4>Objectif restant</h4>
            <p>
              {avancement?.nb_objectif_inProgress !== undefined
                ? avancement?.nb_objectif_inProgress
                : ""}
            </p>
          </TableauElement>{" "}
          <TableauElement data-testid="TableauElement-for_palier">
            <h4>Objectif avant prochain palier </h4>
            <p>
              {avancement?.nb_objectif_for_palier !== undefined &&
              avancement?.nb_objectif_for_palier >= 0
                ? avancement?.nb_objectif_for_palier
                : "0"}
            </p>
          </TableauElement>
        </TableauRow>
      </TableauContent>
    );
  } else return null;
}
